import React from 'react';
import { KIND as TagKind, SIZE, Tag } from 'baseui/tag';
export const RequiredLabelBadge = () => <Tag closeable={false} kind={TagKind.neutral} size={SIZE.xSmall}>
    Required
  </Tag>;